import { render, staticRenderFns } from "./ComertialReportV2.vue?vue&type=template&id=781a595a&scoped=true"
import script from "./ComertialReportV2.vue?vue&type=script&lang=js"
export * from "./ComertialReportV2.vue?vue&type=script&lang=js"
import style0 from "./ComertialReportV2.vue?vue&type=style&index=0&id=781a595a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781a595a",
  null
  
)

export default component.exports